import { AdminUpdateUserPayload, AdminUpdateUserResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminUserCardService {
    public async updateUser(userId: string, payload: AdminUpdateUserPayload): Promise<AdminUpdateUserResult> {
        return api.admin.updateUser(userId, payload)
    }
}

export const service = new AdminUserCardService()